/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-tooltip/TooltipContent';
const styles_TooltipContent:any[] = ([] as any[]);
export const RenderType_TooltipContent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_TooltipContent,
  data: {}
}
);
export function View_TooltipContent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n'])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'role',
        'tooltip'
      ]
    ],[
      [
        8,
        'className',
        0
      ]
      ,
      [
        4,
        'top',
        (null as any)
      ]
      ,
      [
        4,
        'left',
        (null as any)
      ]
      ,
      [
        2,
        'in',
        (null as any)
      ]
      ,
      [
        2,
        'fade',
        (null as any)
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),0,'div',[[
        'class',
        'tooltip-arrow'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),[' \n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),3,'div',[[
        'class',
        'tooltip-inner'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),[
      '\n        ',
      '\n    '
    ]
    )),
    (l()(),import0.ɵted((null as any),[' \n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.TooltipContent = v.component;
    const currVal_0:any = import0.ɵinlineInterpolate(1,'tooltip ',co.placement,'');
    const currVal_1:any = (co.top + 'px');
    const currVal_2:any = (co.left + 'px');
    const currVal_3:any = co.isIn;
    const currVal_4:any = co.isFade;
    ck(v,1,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4);
    const currVal_5:any = co.content;
    ck(v,8,0,currVal_5);
  });
}
function View_TooltipContent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'tooltip-content',([] as any[]),(null as any),(null as any),(null as any),View_TooltipContent_0,RenderType_TooltipContent)),
    import0.ɵdid(4243456,(null as any),0,import1.TooltipContent,[
      import0.ElementRef,
      import0.ChangeDetectorRef
    ]
    ,(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const TooltipContentNgFactory:import0.ComponentFactory<import1.TooltipContent> = import0.ɵccf('tooltip-content',import1.TooltipContent,View_TooltipContent_Host_0,{
  hostElement: 'hostElement',
  content: 'content',
  placement: 'placement',
  animation: 'animation'
}
,{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL25neC10b29sdGlwL1Rvb2x0aXBDb250ZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvbm9kZV9tb2R1bGVzL25neC10b29sdGlwL1Rvb2x0aXBDb250ZW50LmQudHMiLCJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L25vZGVfbW9kdWxlcy9uZ3gtdG9vbHRpcC9Ub29sdGlwQ29udGVudC5kLnRzLlRvb2x0aXBDb250ZW50Lmh0bWwiLCJuZzovLy9zdG9yYWdlL3Zob3N0L3BhbmVsLmRhdGFzcGFjZS5wbC93ZWIvZGF0YXNwYWNlLWNwLWRzLWZyb250L25vZGVfbW9kdWxlcy9uZ3gtdG9vbHRpcC9Ub29sdGlwQ29udGVudC5kLnRzLlRvb2x0aXBDb250ZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG48ZGl2IGNsYXNzPVwidG9vbHRpcCB7eyBwbGFjZW1lbnQgfX1cIlxuICAgICBbc3R5bGUudG9wXT1cInRvcCArICdweCdcIlxuICAgICBbc3R5bGUubGVmdF09XCJsZWZ0ICsgJ3B4J1wiXG4gICAgIFtjbGFzcy5pbl09XCJpc0luXCJcbiAgICAgW2NsYXNzLmZhZGVdPVwiaXNGYWRlXCJcbiAgICAgcm9sZT1cInRvb2x0aXBcIj5cbiAgICA8ZGl2IGNsYXNzPVwidG9vbHRpcC1hcnJvd1wiPjwvZGl2PiBcbiAgICA8ZGl2IGNsYXNzPVwidG9vbHRpcC1pbm5lclwiPlxuICAgICAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgICAgIHt7IGNvbnRlbnQgfX1cbiAgICA8L2Rpdj4gXG48L2Rpdj5cbiIsIjx0b29sdGlwLWNvbnRlbnQ+PC90b29sdGlwLWNvbnRlbnQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQ0FBO01BQ0E7UUFBQTtRQUFBO01BQUE7SUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7UUFBQTtNQUFBOztNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO0lBS29CO01BQ2hCO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBaUM7TUFDakM7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQjtnQkFDdkI7SUFBeUI7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUV2QjtJQUNKOzs7O0lBWEQ7SUFDQTtJQUNBO0lBQ0E7SUFDQTtJQUpMLFNBQUssVUFDQSxVQUNBLFVBQ0EsVUFDQSxTQUpMO0lBUWlDO0lBQUE7Ozs7O0lDVGpDO2dCQUFBOzs7SUFBQTtLQUFBOzs7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/~/ngx-tooltip/TooltipContent.ngfactory.ts